// extracted by mini-css-extract-plugin
module.exports = {"LoadingImage":"loadingdata_LoadingImage__2k9_d"};